import React from 'react'
import { useParams } from 'react-router-dom'
import PaymentConfirmation from '../components/PaymentConfirmation'
import { useAuth } from '../hooks/useSupabaseAuth'
import { componentClasses, cn } from '../utils/designSystem'

const PaymentConfirmationPage = () => {
  const { user } = useAuth()
  const { orderId } = useParams()

  if (!user) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center px-4">
        <div className="text-center max-w-md w-full">
          {/* Logo */}
          <div className="flex items-center justify-center mb-8">
            <img 
              src="https://media.cara.id/images/logo-cara-white.png" 
              alt="Cara Logo" 
              className="h-16"
            />
          </div>
          
          {/* Main Message */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 mb-6">
            <h2 className="text-2xl font-bold text-white mb-3">Konfirmasi Pembayaran</h2>
            <p className="text-gray-400 mb-6">
              Silakan login terlebih dahulu untuk melihat detail transaksi dan konfirmasi pembayaran Anda.
            </p>
            
            <button
              onClick={() => {
                // Dispatch custom event to open auth modal
                window.dispatchEvent(new CustomEvent('openAuthModal'))
              }}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              Login Sekarang
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
          
          {/* Additional Info */}
          <p className="text-sm text-gray-500">
            Belum punya akun? Login dengan Google untuk membuat akun baru.
          </p>
        </div>
      </div>
    )
  }

  return <PaymentConfirmation orderId={orderId} />
}

export default PaymentConfirmationPage